export const clinicInfo = {
  name: "ذا مديكال أفينيو",
  tagline: "منصة متقدمة للطب الدقيق والرعاية التخصصية",
  description: "نقدم طبًا أعمق، أكثر تخصيصًا، ومدعومًا بالتقنيات الدقيقة والخبرة الدولية",
  phone: "+966 11 234 5678",
  email: "info@themedicalavenue.com",
  address: "الرياض، حي العليا، شارع الملك فهد",
  workingHours: "السبت - الخميس: 8 صباحاً - 10 مساءً",
};

export const trustStats = [
  { number: "90–120", label: "دقيقة لكل جلسة تقييم", icon: "ri-time-line" },
  { number: "+30", label: "طبيب متخصص دقيق", icon: "ri-stethoscope-line" },
  { number: "3", label: "أبعاد رعاية متكاملة", icon: "ri-focus-3-line" },
  { number: "4.9", label: "تقييم المرضى", icon: "ri-star-fill" },
];

export const services = [
  {
    id: "risk-stratification",
    name: "تقييم المخاطر الصحية",
    description: "قراءة عميقة للمخاطر الحالية والمستقبلية — نستبق قبل أن نطارد",
    icon: "ri-radar-line",
    image: "https://readdy.ai/api/search-image?query=advanced%20medical%20risk%20assessment%20precision%20medicine%20laboratory%20modern%20clinical%20environment%20dark%20teal%20background%20sophisticated%20diagnostic%20technology%20professional%20healthcare&width=600&height=400&seq=srv-risk1&orientation=landscape",
    color: "from-teal-600/80",
  },
  {
    id: "obesity-metabolic",
    name: "السمنة والخلل الأيضي وMASLD",
    description: "لا نختزل الحالة في الوزن — نتعامل معها كمسار أيضي ووظيفي معقد",
    icon: "ri-scales-line",
    image: "https://readdy.ai/api/search-image?query=metabolic%20medicine%20obesity%20treatment%20advanced%20clinical%20assessment%20modern%20medical%20laboratory%20precision%20diagnostics%20professional%20healthcare%20environment&width=600&height=400&seq=srv-meta1&orientation=landscape",
    color: "from-orange-600/80",
  },
  {
    id: "second-opinion",
    name: "Second Opinion الدولي",
    description: "أداة لاتخاذ قرار أكثر اطمئنانًا في الحالات الحساسة والمعقدة",
    icon: "ri-global-line",
    image: "https://readdy.ai/api/search-image?query=international%20medical%20consultation%20second%20opinion%20global%20healthcare%20network%20professional%20doctors%20meeting%20modern%20clinic%20sophisticated%20environment&width=600&height=400&seq=srv-2op1&orientation=landscape",
    color: "from-slate-600/80",
  },
  {
    id: "dna-risk",
    name: "DNA Risk Score",
    description: "نستخدم تحليل الـ DNA لفهم الاستعدادات والمخاطر المستقبلية",
    icon: "ri-dna-line",
    image: "https://readdy.ai/api/search-image?query=DNA%20genetic%20testing%20precision%20medicine%20laboratory%20advanced%20genomics%20modern%20clinical%20environment%20sophisticated%20technology%20professional%20healthcare&width=600&height=400&seq=srv-dna1&orientation=landscape",
    color: "from-violet-600/80",
  },
  {
    id: "iv-therapy",
    name: "العلاجات الوريدية المتخصصة",
    description: "بروتوكولات وريدية مخصصة مبنية على التقييم الأيضي والوظيفي",
    icon: "ri-drop-line",
    image: "https://readdy.ai/api/search-image?query=intravenous%20IV%20therapy%20specialized%20medical%20treatment%20modern%20clinical%20room%20clean%20professional%20healthcare%20environment%20sophisticated%20equipment&width=600&height=400&seq=srv-iv1&orientation=landscape",
    color: "from-cyan-600/80",
  },
  {
    id: "psychiatry",
    name: "الطب النفسي للبالغين",
    description: "تقييم نفسي عميق متعدد الطبقات مع خطط علاجية شخصية",
    icon: "ri-mental-health-line",
    image: "https://readdy.ai/api/search-image?query=adult%20psychiatry%20mental%20health%20consultation%20modern%20clinical%20environment%20calm%20professional%20therapeutic%20setting%20sophisticated%20healthcare&width=600&height=400&seq=srv-psych1&orientation=landscape",
    color: "from-rose-600/80",
  },
];

export const doctors = [
  {
    id: "dr-faisal",
    name: "د. فيصل الأحمد",
    specialty: "الطب الدقيق وتقييم المخاطر",
    experience: "18 سنة خبرة",
    image: "https://readdy.ai/api/search-image?query=professional%20male%20arab%20doctor%20white%20coat%20stethoscope%20clean%20white%20background%20confident%20authoritative%20portrait%20precision%20medicine%20specialist%20senior&width=400&height=500&seq=doc-ma1&orientation=portrait",
  },
  {
    id: "dr-sara",
    name: "د. سارة المنصور",
    specialty: "الخلل الأيضي وMASLD",
    experience: "14 سنة خبرة",
    image: "https://readdy.ai/api/search-image?query=professional%20female%20arab%20doctor%20white%20coat%20hijab%20clean%20white%20background%20confident%20smile%20portrait%20metabolic%20medicine%20specialist&width=400&height=500&seq=doc-ma2&orientation=portrait",
  },
  {
    id: "dr-khalid",
    name: "د. خالد العمر",
    specialty: "الطب النفسي للبالغين",
    experience: "16 سنة خبرة",
    image: "https://readdy.ai/api/search-image?query=professional%20male%20arab%20doctor%20white%20coat%20glasses%20clean%20white%20background%20confident%20smile%20portrait%20psychiatrist%20specialist%20senior&width=400&height=500&seq=doc-ma3&orientation=portrait",
  },
  {
    id: "dr-nora",
    name: "د. نورة الزهراني",
    specialty: "الجينات والطب الدقيق",
    experience: "12 سنة خبرة",
    image: "https://readdy.ai/api/search-image?query=professional%20female%20arab%20doctor%20white%20coat%20clean%20white%20background%20friendly%20confident%20portrait%20genetics%20precision%20medicine%20specialist&width=400&height=500&seq=doc-ma4&orientation=portrait",
  },
];

export const packages = [
  {
    id: "deep-assessment",
    name: "التقييم العميق الشامل",
    price: "1,200",
    originalPrice: "",
    currency: "ريال",
    badge: "",
    tagline: "90 دقيقة من التقييم متعدد الطبقات",
    icon: "ri-focus-3-line",
    color: "border-gray-200",
    btnColor: "bg-teal-700 hover:bg-teal-800",
    highlight: false,
    features: [
      { text: "جلسة تقييم 90 دقيقة مع استشاري أول", included: true },
      { text: "تحليل التاريخ الصحي والمخاطر الوراثية", included: true },
      { text: "تحاليل وظيفية وأيضية متخصصة", included: true },
      { text: "قراءة المخاطر الحالية والمستقبلية", included: true },
      { text: "تقرير سريري مفصل مع خطة شخصية", included: true },
      { text: "DNA Risk Score", included: false },
      { text: "Second Opinion دولي", included: false },
      { text: "متابعة لصيقة 6 أشهر", included: false },
    ],
  },
  {
    id: "precision-plus",
    name: "منصة الطب الدقيق",
    price: "2,800",
    originalPrice: "3,500",
    currency: "ريال",
    badge: "الأكثر طلباً",
    tagline: "التقييم العميق + DNA + خطة شخصية متكاملة",
    icon: "ri-dna-line",
    color: "border-teal-500",
    btnColor: "bg-teal-700 hover:bg-teal-800",
    highlight: true,
    features: [
      { text: "جلسة تقييم 120 دقيقة مع استشاري أول", included: true },
      { text: "DNA Risk Score كامل", included: true },
      { text: "تحليل العمر البيولوجي", included: true },
      { text: "تقييم أيضي ووظيفي متعدد الطبقات", included: true },
      { text: "قراءة المخاطر المستقبلية", included: true },
      { text: "خطة علاجية شخصية مفصلة", included: true },
      { text: "متابعة لصيقة 6 أشهر", included: true },
      { text: "Second Opinion دولي عند الحاجة", included: false },
    ],
  },
  {
    id: "global-care",
    name: "الرعاية الدولية المتكاملة",
    price: "5,500",
    originalPrice: "7,000",
    currency: "ريال",
    badge: "حصري",
    tagline: "طب دقيق + خبرة دولية + متابعة مستمرة",
    icon: "ri-global-line",
    color: "border-gray-200",
    btnColor: "bg-slate-700 hover:bg-slate-800",
    highlight: false,
    features: [
      { text: "تقييم عميق متعدد التخصصات", included: true },
      { text: "DNA Risk Score + العمر البيولوجي", included: true },
      { text: "Second Opinion من مراكز دولية (USA / Korea)", included: true },
      { text: "تحاليل DNA النفسية والجينية", included: true },
      { text: "خطة علاجية شخصية شاملة", included: true },
      { text: "متابعة لصيقة سنة كاملة", included: true },
      { text: "ربط مستمر بمؤشرات الحالة", included: true },
      { text: "تطبيق مراقبة صحية شخصي", included: true },
    ],
  },
];

export const blogPosts = [
  {
    id: "precision-medicine-future",
    title: "الطب الدقيق: لماذا لم تعد الحلول العامة كافية؟",
    excerpt: "كل مريض يملك بيولوجيا ومسارًا صحيًا مختلفًا. نفهم قبل أن نقرر، ونحلل قبل أن نتدخل، ونستبق قبل أن نطارد.",
    content: "الطب الدقيق ليس مجرد مصطلح علمي، بل نموذج رعاية متكامل يقوم على فهم الفروق البيولوجية بين الأفراد.",
    category: "الطب الدقيق",
    categoryId: "risk-stratification",
    author: "د. فيصل الأحمد",
    authorRole: "استشاري الطب الدقيق وتقييم المخاطر",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20male%20arab%20doctor%20white%20coat%20stethoscope%20clean%20white%20background%20confident%20authoritative%20portrait%20precision%20medicine%20specialist%20senior&width=100&height=100&seq=doc-ma1&orientation=squarish",
    date: "15 أبريل 2026",
    readTime: "6 دقائق",
    image: "https://readdy.ai/api/search-image?query=precision%20medicine%20DNA%20genomics%20advanced%20medical%20technology%20laboratory%20modern%20clinical%20environment%20sophisticated%20diagnostics%20professional%20healthcare%20concept&width=800&height=500&seq=blog-pm1&orientation=landscape",
    tags: ["الطب الدقيق", "DNA", "المخاطر الصحية"],
    featured: true,
    views: 3240,
  },
  {
    id: "masld-metabolic",
    title: "MASLD والخلل الأيضي: أكثر من مجرد مشكلة وزن",
    excerpt: "لا نختزل الحالة في الوزن، بل نتعامل معها كمسار أيضي ووظيفي معقد يحتاج قراءة أعمق وتدخلًا أكثر تخصيصًا.",
    content: "MASLD أو مرض الكبد الدهني المرتبط بالخلل الأيضي يمثل أحد أكثر الحالات تعقيدًا في الطب الحديث.",
    category: "الخلل الأيضي",
    categoryId: "obesity-metabolic",
    author: "د. سارة المنصور",
    authorRole: "استشارية الخلل الأيضي وMASLD",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20female%20arab%20doctor%20white%20coat%20hijab%20clean%20white%20background%20confident%20smile%20portrait%20metabolic%20medicine%20specialist&width=100&height=100&seq=doc-ma2&orientation=squarish",
    date: "10 أبريل 2026",
    readTime: "8 دقائق",
    image: "https://readdy.ai/api/search-image?query=metabolic%20syndrome%20liver%20disease%20MASLD%20medical%20concept%20advanced%20clinical%20assessment%20laboratory%20modern%20healthcare%20professional%20environment&width=800&height=500&seq=blog-meta1&orientation=landscape",
    tags: ["MASLD", "الخلل الأيضي", "السمنة"],
    featured: true,
    views: 2180,
  },
  {
    id: "second-opinion-value",
    title: "Second Opinion: متى يكون القرار الطبي الإضافي ضرورة لا رفاهية؟",
    excerpt: "الرأي الطبي الإضافي عندنا ليس خدمة شكلية، بل أداة لاتخاذ قرار أكثر اطمئنانًا واتساعًا في الحالات الحساسة.",
    content: "في الحالات المعقدة، الحصول على رأي طبي ثانٍ من مراكز دولية متخصصة قد يغير مسار العلاج بالكامل.",
    category: "Second Opinion",
    categoryId: "second-opinion",
    author: "د. فيصل الأحمد",
    authorRole: "استشاري الطب الدقيق",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20male%20arab%20doctor%20white%20coat%20stethoscope%20clean%20white%20background%20confident%20authoritative%20portrait%20precision%20medicine%20specialist%20senior&width=100&height=100&seq=doc-ma1&orientation=squarish",
    date: "5 أبريل 2026",
    readTime: "5 دقائق",
    image: "https://readdy.ai/api/search-image?query=international%20medical%20consultation%20second%20opinion%20global%20healthcare%20network%20professional%20doctors%20collaboration%20modern%20clinic%20sophisticated%20environment&width=800&height=500&seq=blog-2op1&orientation=landscape",
    tags: ["Second Opinion", "القرار الطبي", "الخبرة الدولية"],
    featured: false,
    views: 1920,
  },
  {
    id: "dna-risk-score",
    title: "DNA Risk Score: قراءة مستقبلك الصحي قبل أن يحدث",
    excerpt: "نستخدم تحليل الـ DNA لفهم الاستعدادات والمخاطر المستقبلية، لا لمجرد الانبهار العلمي أو الاستعراض التقني.",
    content: "تحليل DNA Risk Score يكشف الاستعدادات الجينية للأمراض قبل ظهورها، مما يتيح التدخل الوقائي المبكر.",
    category: "الجينات والطب الدقيق",
    categoryId: "dna-risk",
    author: "د. نورة الزهراني",
    authorRole: "استشارية الجينات والطب الدقيق",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20female%20arab%20doctor%20white%20coat%20clean%20white%20background%20friendly%20confident%20portrait%20genetics%20precision%20medicine%20specialist&width=100&height=100&seq=doc-ma4&orientation=squarish",
    date: "1 أبريل 2026",
    readTime: "7 دقائق",
    image: "https://readdy.ai/api/search-image?query=DNA%20genetic%20testing%20risk%20score%20precision%20medicine%20laboratory%20advanced%20genomics%20modern%20clinical%20environment%20sophisticated%20technology%20professional%20healthcare&width=800&height=500&seq=blog-dna1&orientation=landscape",
    tags: ["DNA", "الجينات", "الوقاية المبكرة"],
    featured: false,
    views: 2650,
  },
  {
    id: "biological-aging",
    title: "العمر البيولوجي: أنت أصغر أو أكبر مما تظن",
    excerpt: "العمر الزمني لا يحكي القصة كاملة. العمر البيولوجي يكشف الحقيقة الفعلية لحالة جسمك على المستوى الخلوي.",
    content: "قياس العمر البيولوجي يتجاوز الأرقام ليكشف مدى تقدم الشيخوخة الخلوية ومدى استجابة الجسم للعوامل البيئية.",
    category: "الطب الدقيق",
    categoryId: "risk-stratification",
    author: "د. نورة الزهراني",
    authorRole: "استشارية الجينات والطب الدقيق",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20female%20arab%20doctor%20white%20coat%20clean%20white%20background%20friendly%20confident%20portrait%20genetics%20precision%20medicine%20specialist&width=100&height=100&seq=doc-ma4&orientation=squarish",
    date: "28 مارس 2026",
    readTime: "6 دقائق",
    image: "https://readdy.ai/api/search-image?query=biological%20aging%20cellular%20health%20precision%20medicine%20advanced%20diagnostics%20modern%20laboratory%20sophisticated%20medical%20technology%20professional%20healthcare%20concept&width=800&height=500&seq=blog-age1&orientation=landscape",
    tags: ["العمر البيولوجي", "الشيخوخة", "الطب الدقيق"],
    featured: false,
    views: 1840,
  },
  {
    id: "psychiatry-depth",
    title: "الطب النفسي العميق: ما وراء الأعراض",
    excerpt: "التقييم النفسي الحقيقي لا يكتفي بالأعراض، بل يقرأ البنية الكاملة للحالة ويربطها بالعوامل البيولوجية والنفسية.",
    content: "الطب النفسي للبالغين في ذا مديكال أفينيو يقوم على تقييم عميق متعدد الطبقات يتجاوز البروتوكولات التقليدية.",
    category: "الطب النفسي",
    categoryId: "psychiatry",
    author: "د. خالد العمر",
    authorRole: "استشاري الطب النفسي للبالغين",
    authorImage: "https://readdy.ai/api/search-image?query=professional%20male%20arab%20doctor%20white%20coat%20glasses%20clean%20white%20background%20confident%20smile%20portrait%20psychiatrist%20specialist%20senior&width=100&height=100&seq=doc-ma3&orientation=squarish",
    date: "24 مارس 2026",
    readTime: "5 دقائق",
    image: "https://readdy.ai/api/search-image?query=adult%20psychiatry%20mental%20health%20deep%20assessment%20modern%20clinical%20environment%20calm%20professional%20therapeutic%20setting%20sophisticated%20healthcare%20concept&width=800&height=500&seq=blog-psych1&orientation=landscape",
    tags: ["الطب النفسي", "التقييم العميق", "الصحة النفسية"],
    featured: false,
    views: 2120,
  },
];

export const blogCategories = [
  { id: "all", label: "الكل" },
  { id: "risk-stratification", label: "الطب الدقيق" },
  { id: "obesity-metabolic", label: "الخلل الأيضي" },
  { id: "second-opinion", label: "Second Opinion" },
  { id: "dna-risk", label: "الجينات" },
  { id: "psychiatry", label: "الطب النفسي" },
];

export const faqCategories = [
  { id: "general", label: "عام", icon: "ri-question-line" },
  { id: "booking", label: "الحجز والمواعيد", icon: "ri-calendar-line" },
  { id: "packages", label: "الباقات والأسعار", icon: "ri-price-tag-3-line" },
  { id: "services", label: "الخدمات الطبية", icon: "ri-stethoscope-line" },
];

export const faqs = [
  {
    id: 1,
    category: "general",
    question: "ما الذي يميز ذا مديكال أفينيو عن العيادات التقليدية؟",
    answer: "ذا مديكال أفينيو ليست عيادة تقليدية محسّنة، بل منصة متقدمة للطب الدقيق والرعاية التخصصية. نقدم جلسات تقييم تمتد من 90 إلى 120 دقيقة، نفكك فيها الحالة ونقرأ ما وراء العرض، ونربط بين الحاضر الصحي والمخاطر المستقبلية. نستخدم تقنيات دقيقة كـ DNA Risk Score وتحليل العمر البيولوجي، مع امتداد دولي عبر Second Opinion من مراكز في الولايات المتحدة وجنوب كوريا.",
  },
  {
    id: 2,
    category: "general",
    question: "من هو المريض المناسب لذا مديكال أفينيو؟",
    answer: "نخدم المرضى الذين لم تمنحهم الزيارات السريعة صورة واضحة، ويحتاجون تقييمًا متعدد الطبقات، ويبحثون عن خطة شخصية لا بروتوكولًا عامًا. أيضًا من يحتاجون أحيانًا إلى Second Opinion وخبرة أوسع من الإطار المحلي.",
  },
  {
    id: 3,
    category: "general",
    question: "ما هي ساعات عمل المنصة؟",
    answer: "تعمل ذا مديكال أفينيو من السبت إلى الخميس من الساعة 8:00 صباحًا حتى 10:00 مساءً. نوفر مواعيد مرنة تناسب جدولك بما في ذلك المساء.",
  },
  {
    id: 4,
    category: "general",
    question: "هل تقبلون التأمين الطبي؟",
    answer: "نتعامل مع معظم شركات التأمين الطبي المعتمدة. يُرجى التواصل معنا مسبقًا للتحقق من تغطية شركة التأمين الخاصة بك.",
  },
  {
    id: 5,
    category: "booking",
    question: "كيف يمكنني حجز جلسة تقييم؟",
    answer: "يمكنك حجز جلسة التقييم عبر موقعنا الإلكتروني من خلال صفحة الحجز، أو الاتصال على رقم هاتف المنصة، أو التواصل عبر واتساب. نضمن لك الرد خلال ساعة واحدة من وقت الطلب.",
  },
  {
    id: 6,
    category: "booking",
    question: "هل يمكنني إلغاء أو تغيير موعدي؟",
    answer: "نعم، يمكنك إلغاء أو تغيير موعدك قبل 24 ساعة على الأقل من الموعد المحدد دون أي رسوم.",
  },
  {
    id: 7,
    category: "booking",
    question: "ماذا يجب أن أحضر معي في الجلسة الأولى؟",
    answer: "يُرجى إحضار: بطاقة الهوية الوطنية أو الإقامة، بطاقة التأمين الطبي إن وجدت، أي تقارير طبية أو نتائج تحاليل سابقة، وقائمة الأدوية التي تتناولها حاليًا. كلما كانت المعلومات أكثر، كان التقييم أعمق.",
  },
  {
    id: 8,
    category: "booking",
    question: "كم تستغرق جلسة التقييم؟",
    answer: "جلسات التقييم في ذا مديكال أفينيو تمتد من 90 إلى 120 دقيقة. نمنح الحالات المعقدة الوقت الذي تستحقه، لأن بعض الملفات لا تُفهم في دقائق.",
  },
  {
    id: 9,
    category: "packages",
    question: "ما الفرق بين الباقات المتاحة؟",
    answer: "نقدم 3 مستويات: التقييم العميق الشامل (1,200 ريال) للتقييم متعدد الطبقات، ومنصة الطب الدقيق (2,800 ريال) التي تضيف DNA Risk Score والعمر البيولوجي، والرعاية الدولية المتكاملة (5,500 ريال) التي تشمل Second Opinion من مراكز دولية ومتابعة سنة كاملة.",
  },
  {
    id: 10,
    category: "packages",
    question: "هل يمكن تخصيص الباقة حسب حالتي؟",
    answer: "نعم، كل مريض يملك بيولوجيا ومسارًا صحيًا مختلفًا. نصمم لكل مريض خطة مبنية على تقييمه الفعلي، لا على بروتوكول عام.",
  },
  {
    id: 11,
    category: "packages",
    question: "ما هي مدة صلاحية الباقة؟",
    answer: "باقة التقييم العميق صالحة 6 أشهر، ومنصة الطب الدقيق صالحة سنة كاملة، والرعاية الدولية المتكاملة تشمل متابعة سنة كاملة مع إمكانية التجديد.",
  },
  {
    id: 12,
    category: "services",
    question: "ما هي الخدمات ذات الأولوية في ذا مديكال أفينيو؟",
    answer: "خدماتنا الأعلى قدرة على التمييز والتحويل تشمل: Risk Stratification، السمنة والخلل الأيضي وMASLD، Second Opinion الدولي، DNA Risk Score، العلاجات الوريدية المتخصصة، الطب النفسي للبالغين، وهشاشة العظام المكثفة.",
  },
  {
    id: 13,
    category: "services",
    question: "ما هو Second Opinion الدولي وكيف يعمل؟",
    answer: "Second Opinion الدولي هو خدمة منظمة لإرسال ملف المريض إلى مراكز طبية متخصصة في الولايات المتحدة وجنوب كوريا وغيرها، للحصول على رأي طبي إضافي في الحالات المعقدة أو الحساسة. ليس خدمة شكلية، بل أداة لاتخاذ قرار أكثر اطمئنانًا.",
  },
  {
    id: 14,
    category: "services",
    question: "ما هو DNA Risk Score وماذا يكشف؟",
    answer: "DNA Risk Score هو تحليل جيني متخصص يكشف الاستعدادات الوراثية للأمراض المستقبلية، مما يتيح التدخل الوقائي المبكر قبل ظهور الأعراض. نستخدمه لفهم المخاطر الحقيقية، لا للاستعراض التقني.",
  },
  {
    id: 15,
    category: "services",
    question: "كيف تتم متابعة الحالة بعد التقييم؟",
    answer: "رعايتنا لا تنتهي عند التشخيص، بل تمتد إلى المتابعة اللصيقة، والخطة الشخصية، والربط المستمر بمؤشرات الحالة عبر تطبيق مراقبة صحية شخصي.",
  },
  {
    id: 16,
    category: "services",
    question: "هل تتوفر خدمات الطب النفسي للبالغين؟",
    answer: "نعم، نقدم تقييمًا نفسيًا عميقًا متعدد الطبقات يتجاوز البروتوكولات التقليدية، مع خطط علاجية شخصية تربط بين الأبعاد البيولوجية والنفسية والاجتماعية.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "م. عبدالرحمن الفيصل",
    text: "بعد سنوات من الزيارات السريعة التي لم تعطني صورة واضحة، جاءت جلسة التقييم في ذا مديكال أفينيو لتغير كل شيء. 90 دقيقة من الاستماع الحقيقي والتحليل العميق. أخيرًا فهمت ما يحدث في جسمي.",
    rating: 5,
    specialty: "مريض — منصة الطب الدقيق",
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20man%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2045%20years%20old&width=100&height=100&seq=test-ma1&orientation=squarish",
  },
  {
    id: 2,
    name: "د. منى الشريف",
    text: "DNA Risk Score كشف استعدادًا وراثيًا لم أكن أعلم به. الآن لدي خطة وقائية حقيقية مبنية على بيولوجيتي الخاصة، لا على بروتوكول عام. هذا هو الطب الذي كنت أبحث عنه.",
    rating: 5,
    specialty: "مريضة — DNA Risk Score",
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20woman%20hijab%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2038%20years%20old&width=100&height=100&seq=test-ma2&orientation=squarish",
  },
  {
    id: 3,
    name: "خالد المطيري",
    text: "Second Opinion من مركز أمريكي متخصص غيّر قرار العلاج بالكامل. الفريق في ذا مديكال أفينيو نظّم كل شيء باحترافية عالية. هذا ليس مجرد رأي إضافي، هذا قرار طبي أكثر اطمئنانًا.",
    rating: 5,
    specialty: "مريض — Second Opinion الدولي",
    image: "https://readdy.ai/api/search-image?query=arab%20professional%20man%20portrait%20confident%20friendly%20smile%20clean%20white%20background%20business%20casual%20attire%2052%20years%20old&width=100&height=100&seq=test-ma3&orientation=squarish",
  },
];

export const whyUs = [
  {
    icon: "ri-time-line",
    title: "جلسات 90–120 دقيقة",
    description: "نمنح الحالات المعقدة الوقت الذي تستحقه — لأن بعض الملفات لا تُفهم في دقائق",
  },
  {
    icon: "ri-stack-line",
    title: "تقييم متعدد الطبقات",
    description: "نفكك الحالة ونقرأ ما وراء العرض، ونربط بين الحاضر الصحي والمخاطر المستقبلية",
  },
  {
    icon: "ri-dna-line",
    title: "تقنيات الطب الدقيق",
    description: "DNA Risk Score، العمر البيولوجي، التقييم الأيضي الوظيفي — أدوات حقيقية لقرار طبي حقيقي",
  },
  {
    icon: "ri-global-line",
    title: "امتداد دولي حقيقي",
    description: "شبكة علاقات وخبرات في الولايات المتحدة وجنوب كوريا — Second Opinion منظم للحالات المعقدة",
  },
];

export const aboutValues = [
  {
    icon: "ri-search-eye-line",
    title: "نفهم قبل أن نقرر",
    description: "التقييم العميق هو أساس كل قرار طبي — لا نتسرع ولا نختزل الحالة في بروتوكول عام",
  },
  {
    icon: "ri-microscope-line",
    title: "نحلل قبل أن نتدخل",
    description: "نستخدم الأدوات الدقيقة لخدمة قرار طبي حقيقي، لا لصناعة صورة براقة",
  },
  {
    icon: "ri-shield-flash-line",
    title: "نستبق قبل أن نطارد",
    description: "الوقاية الذكية تبدأ قبل مرحلة التفاقم — نقرأ المخاطر قبل أن تتحول إلى واقع",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "إنسانية بلا رخاوة",
    description: "عميقة ومطمئنة، دقيقة ومتقدمة، راقية دون تصنع — علمية دون مبالغة",
  },
];

export const allServices = [
  ...services,
  {
    id: "osteoporosis",
    name: "هشاشة العظام المكثفة",
    description: "رعاية متخصصة ومكثفة لهشاشة العظام مع خطط علاجية شخصية",
    icon: "ri-body-scan-line",
    image: "https://readdy.ai/api/search-image?query=osteoporosis%20bone%20density%20advanced%20medical%20treatment%20modern%20clinical%20environment%20professional%20healthcare%20sophisticated%20diagnostics&width=600&height=400&seq=srv-osteo1&orientation=landscape",
    color: "from-amber-600/80",
  },
  {
    id: "mitochondrial",
    name: "خلل الميتوكوندريا",
    description: "تشخيص وعلاج اضطرابات الطاقة الخلوية بأحدث التقنيات",
    icon: "ri-flashlight-line",
    image: "https://readdy.ai/api/search-image?query=mitochondrial%20dysfunction%20cellular%20energy%20medicine%20advanced%20laboratory%20precision%20diagnostics%20modern%20clinical%20environment%20professional%20healthcare&width=600&height=400&seq=srv-mito1&orientation=landscape",
    color: "from-green-600/80",
  },
  {
    id: "alzheimer",
    name: "الزهايمر والتنكس العصبي",
    description: "تقييم مبكر وخطط وقائية للحالات عالية الخطورة",
    icon: "ri-brain-line",
    image: "https://readdy.ai/api/search-image?query=Alzheimer%20neurodegeneration%20brain%20health%20advanced%20medical%20assessment%20modern%20clinical%20environment%20sophisticated%20diagnostics%20professional%20healthcare&width=600&height=400&seq=srv-alz1&orientation=landscape",
    color: "from-slate-600/80",
  },
];
